import { Check } from "lucide-react";

import LoadingSpinner from "@/components/LoadingSpinner";
import { cn } from "@/lib/utils";

interface SaveStatusContentProps {
  state: "saving" | "success";
  title: string;
  description: string;
  className?: string;
}

export const SaveStatusContent = ({
  state,
  title,
  description,
  className,
}: SaveStatusContentProps) => (
  <div
    className={cn("flex min-h-[180px] flex-col items-center justify-center text-center", className)}
  >
    <div
      className={cn(
        "mb-5 flex h-8 w-8 items-center justify-center rounded-full transition-colors duration-300",
        state === "success" && "bg-emerald-100",
      )}
    >
      {state === "saving" ? (
        <LoadingSpinner size={6} className="!mr-0" />
      ) : (
        <Check className="h-5 w-5 text-emerald-500 transition-opacity duration-300 animate-in fade-in-0" />
      )}
    </div>
    <p className="text-lg font-semibold text-gray-900 transition-opacity duration-300 animate-in fade-in-0">
      {title}
    </p>
    <p className="mt-2 max-w-sm text-sm leading-6 text-gray-500 transition-opacity duration-300 animate-in fade-in-0">
      {description}
    </p>
  </div>
);
